"use strict";
var zip_1 = require('./zip');
function zipAll(project) {
    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/rxjs/operators/zipAll.js
// module id = ../../../../rxjs/operators/zipAll.js
// module chunks = 4